import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const variants = {
	default: "px-4 p-2",
	square: "p-2",
};

interface TabProps {
	variant: keyof typeof variants;
	children?: any;
	color: any;
	className?: string;
	onClick?: () => void;
	active?: boolean;
	to?: string;
	ref?: any;
	small?: boolean;
	padding?: string;
	element?: "div" | "button";
}

const Tab = ({
	variant,
	children,
	onClick,
	color,
	className,
	active,
	to,
	ref,
	element,
}: TabProps) => {
	const location = useLocation();
	const _active = to ? location.pathname === to : false;
	const As = element || "div";
	let classes = active || _active ? `bg-${color} shadow opacity-100` : ``;

	const renderTab = () => (
		<As
			{...{ onClick }}
			className={`cursor-pointer rounded-md flex justify-center items-center gap-2 whitespace-nowrap transition-all font-bold ${classes} text-[16px] ${
				variants[variant]
			} ${className || ""}`}
			{...{ ref }}
		>
			{children}
		</As>
	);

	if (to) {
		return <NavLink {...{ to }}>{renderTab()}</NavLink>;
	}

	return renderTab();
};

Tab.defaultProps = {
	color: "white",
	variant: "default",
};

export default Tab;
